<mat-card class="alert-warning w-100 p-2">
    <div class="d-flex align-items-center">
        <mat-icon class="mr-1">lock</mat-icon>
        <span *ngIf="lock.unverified; else imported" class="unverified">
            <strong>Modification indisponible</strong> — impossible de vérifier si un voyage du nouveau
            back-office a repris cette prestation. La fiche reste consultable ici ; rechargez la page
            pour réessayer.
        </span>
        <ng-template #imported>
            <span>
                <strong>Reprise dans Trip</strong> — le produit n°{{ lock.productId }} qui l'utilise a été
                importé dans un voyage du nouveau back-office : elle s'y modifie désormais. La fiche reste
                consultable ici, sans modification.
                <a *ngIf="prestationUrl" class="prestation-link" [href]="prestationUrl" target="_blank" rel="noopener">Ouvrir dans le nouveau back-office</a>
                <ng-container *ngIf="prestationUrl && tripUrl"> · </ng-container>
                <a *ngIf="tripUrl" class="trip-link" [href]="tripUrl" target="_blank" rel="noopener">Voir le voyage</a>
            </span>
        </ng-template>
    </div>
</mat-card>
